const MobileLayout = (props) => {
  return <>{props.children}</>;
};

export default MobileLayout;
